import { t } from 'i18next';

import TitleLabel from 'components/TitleLabel/TitleLabel';

import DailyMessage from './DailyMessage';
import './DailyMessageList.scoped.scss';

interface Props {
  upcoming: Array<any>;
  ongoing: Array<any>;
  previous: Array<any>;
}

const DailyMessageList: React.FC<Props> = ({ upcoming, ongoing, previous }) => {
  return (
    <>
      <div className="title-wrapper">
        <TitleLabel>{t('common:upcoming')}</TitleLabel>
        <div className="wrapper">
          {upcoming.map(elem => {
            return <DailyMessage name={elem.message} date={elem.eventDate} key={Math.random()} />;
          })}
        </div>
      </div>

      <div className="title-wrapper">
        <TitleLabel>{t('common:ongoing')}</TitleLabel>
        <div className="wrapper">
          {ongoing.map(elem => {
            return <DailyMessage name={elem.message} date={elem.eventDate} key={Math.random()} />;
          })}
        </div>
      </div>

      <div className="title-wrapper">
        <TitleLabel>{t('study:previous')}</TitleLabel>
        <div className="wrapper">
          {previous.map(elem => {
            return <DailyMessage name={elem.message} date={elem.eventDate} key={Math.random()} />;
          })}
        </div>
      </div>
    </>
  );
};

export default DailyMessageList;
